'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002422 from "./presto.-Agent-View$$anon$22.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024 from "./presto.types$proto$-File-Content$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$21() {
  this.axy = null;
  this.axq = null;
  this.axr = false;
  this.axz = null;
  this.axA = false;
  this.axD = null;
  this.axw = null;
  this.axx = false;
  this.axs = null;
  this.axt = false;
  this.axu = null;
  this.axv = false;
  this.axB = false;
  this.axC = false;
  this.axy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axD = "FileContent";
}
export { $c_Lpresto_AgentView$$anon$21 as $c_Lpresto_AgentView$$anon$21 };
$p = $c_Lpresto_AgentView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$21;
/** @constructor */
function $h_Lpresto_AgentView$$anon$21() {
}
export { $h_Lpresto_AgentView$$anon$21 as $h_Lpresto_AgentView$$anon$21 };
$h_Lpresto_AgentView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.axy;
});
$p.L = (function() {
  if ((!this.axr)) {
    this.axq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axr = true;
  }
  return this.axq;
});
$p.O = (function() {
  if ((!this.axA)) {
    this.axz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axA = true;
  }
  return this.axz;
});
$p.E = (function() {
  return this.axD;
});
$p.t = (function() {
  if ((!this.axx)) {
    this.axw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axx = true;
  }
  return this.axw;
});
$p.M = (function() {
  if ((!this.axt)) {
    this.axs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().r2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axt = true;
  }
  return this.axs;
});
$p.Q = (function() {
  if ((!this.axv)) {
    this.axu = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002422.$c_Lpresto_AgentView$$anon$22();
    this.axv = true;
  }
  return this.axu;
});
$p.w = (function() {
  if ((!this.axC)) {
    this.axB = false;
    this.axC = true;
  }
  return this.axB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee149) => ((p) => \u03b4scrutinee149.cGS(p)))($j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024.$m_Lpresto_types$proto$FileContent$())));
});
var $d_Lpresto_AgentView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$21, "presto.AgentView$$anon$21", ({
  DL: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$21 as $d_Lpresto_AgentView$$anon$21 };
//# sourceMappingURL=presto.-Agent-View$$anon$21.js.map
